<template>
  <div class="container">
    <div class="error-content">
      <h1 class="mds-level-3-heading">Page Not Found</h1>
      <p class="mds-body-text-m">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <mds-button
        variation="primary"
        @click="goHome"
        class="home-button"
      >
        Return to Home
      </mds-button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { MdsButton } from '@mds/button-vue3'

// Composables
const router = useRouter()

// Methods
const goHome = () => {
  router.push('/')
}
</script>

<style lang="scss" scoped>
@import '@/styles/constants';

.container {
  margin-top: 82px;
  width: 620px;
  margin-left: auto;
  margin-right: auto;
  min-height: 500px;
  padding: $mds-space-4-x;
}

.error-content {
  text-align: center;
  padding: $mds-space-4-x 0;
  
  .home-button {
    margin-top: $mds-space-4-x;
  }
}
</style>
